let $swipers = $('.js-swiper')
let autoplayDelay = 4000 // + carousel__nav.sass
let mobile = window.innerWidth <= 768

$swipers.each(function() {
	let $this = $(this)
	let type = $this.attr('data-type')
	let widget = $this.attr('data-widget')
	let $parent = $this.closest('.swiper')
	let $navNextEl = $parent.find('.js-swiper-next')
	let $navPrevEl = $parent.find('.js-swiper-prev')
	let $paginationEl = $parent.find('.js-swiper-pagination')
	let $progress = $parent.find('.carousel__nav__progress')

	let args = {
		init: false,
		loop: true,
		speed: 300,
		simulateTouch: false,
		autoplay: {
			delay: autoplayDelay
		},
		pagination: {
			clickable: true,
			el: $paginationEl[0]
		},
		navigation: {
			nextEl: $navNextEl[0],
			prevEl: $navPrevEl[0]
		},
	}

	if (type == 'fade') {
		let extraArgs = {
			effect: 'fade',
			loopAdditionalSlides: 1,
			loop: true,
			fadeEffect: {
		    crossFade: true
		  }
		}

		Object.assign(args, extraArgs)
	}

	if (type == 'bubbles') {
		if(mobile) {
			var extraArgs = {
				effect: 'slide',
				loopAdditionalSlides: 2,
				spaceBetween: 50
			}
		} else {
			var extraArgs = {
				effect: 'fade',
				loopAdditionalSlides: 2,
				fadeEffect: {
			    crossFade: false
			  }
			}
		}

		Object.assign(args, extraArgs)
	}

	let swiper = new Swiper ($this[0], args)

	swiper.on('init', function () {
	  $progress.addClass('start')
	});

	swiper.on('slideChangeTransitionStart', function () {
	  $progress.removeClass('start')
	});

	swiper.on('slideNextTransitionStart', function () {
	  $this.addClass('swiper-animate').find('.swiper-slide-prev').addClass('slide-animate');
	});

	swiper.on('slidePrevTransitionStart', function () {
	  $this.addClass('swiper-animate-prev').find('.swiper-slide-next').addClass('slide-animate-prev');
	});

	swiper.on('slideChangeTransitionEnd', function () {
		if($this.attr('data-paused') === undefined) {
	  	$progress.addClass('start')
		}

	  $this.removeClass('swiper-animate swiper-animate-prev').find('.swiper-slide').removeClass('slide-animate slide-animate-prev');
	});

	swiper.on('autoplayStop', function () {
		$this.attr('data-paused', true)
	})

	if (widget) {
		let $widgetWrapper = $parent.find('.swiper-widget-wrapper')

		$widgetWrapper.each(function() {
			let $this = $(this)
			let $widget = $this.find('.swiper-widget')
			let fixedHeight = $this.attr('data-fixedheight')

			if(fixedHeight){
				$this.height($widget.outerHeight())
			}

			$this.addClass('initialized')

			swiper.on('slideChangeTransitionStart', function (e) {
				let active = swiper.realIndex

				$widget.removeClass('swiper-widget-active')
			  $widget.eq(active).addClass('swiper-widget-active')
			});
		});

	}

	swiper.init()

})
